<div
  class="tab-pane fade flex-even active show"
  id="contacts"
  role="tabpanel"
  aria-labelledby="contacts-tab"
  formGroupName="marketingFormGroup"
  >
  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
            >CONTACT_LBL_SALESPERSON</label
            >
            <div class="col">
              <app-typeahead
                [entity]="Entity.SalesTeam"
                [routeEndpoint]="'SalesTeams/SalesTeamMembers'"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get('salesPersonId')
              "
                [limitToList]="true"
                [dbNameOfName]="'UserContactName'"
                [dbNameOfId]="'UserId'"
                [domain]="'UserAspNetUserEmailConfirmed=true,SalesTeamActive=true'"
                [pageSize]="50"
              ></app-typeahead>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >CONTACT_LBL_SALESTEAM</label
              >
              <div class="col">
                <app-typeahead
                  [entity]="Entity.SalesTeam"
                  [routeEndpoint]="'SalesTeams/SalesTeams'"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get('salesTeamId')
              "
                  [limitToList]="true"
                  [dbNameOfName]="'SalesTeamName'"
                  [dbNameOfId]="'SalesTeamId'"
                  [domain]="!!this.form.controls['marketingFormGroup'].get('salesPersonId')?.value ? 'userId='+this.form.controls['marketingFormGroup'].get('salesPersonId')?.value : 'userId=0'+ ',salesTeamActive=true'"
                  [alwaysUseDomain]="true"
                ></app-typeahead>
              </div>
            </div>

            @if (isCampaignReferral) {
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >CONTACT_LBL_MARKETING_REFERRER</label
                  >
                  <div class="col">
                    <app-typeahead
                      [routeEndpoint]="'Contacts'"
                      [entity]="Entity.Contact"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get(
                  'marketingReferrerId'
                )
              "
                      [orderBy]="'name asc'"
                      [allowCustomActions]="true"
                      [limitToList]="true"
                      [placeholder]="'TYPEAHEAD_LBL_TYPE_TO_SEARCH_TEXT' | translate"
                    ></app-typeahead>
                  </div>
                </div>
              }
            </div>
            <div class="col">
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >CONTACT_LBL_MARKETING_CAMPAIGN</label
                  >
                  <div class="col">
                    <app-typeahead
                      [entity]="Entity.Campaign"
                      [routeEndpoint]="'Campaigns'"
                      [limitToList]="true"
                      [pageSize]="30"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get(
                  'marketingCampaignId'
                )
              "
                    ></app-typeahead>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-form-label-sm" translate
                    >CONTACT_LBL_MARKETING_MEDIUM</label
                    >
                    <div class="col">
                      <app-typeahead
                        [entity]="Entity.Medium"
                        [routeEndpoint]="'Mediums'"
                        [limitToList]="false"
                        [pageSize]="30"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get('marketingMediumId')
              "
                      ></app-typeahead>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 col-form-label-sm" translate
                      >CONTACT_LBL_MARKETING_SOURCE</label
                      >
                      <div class="col">
                        <app-typeahead
                          [entity]="Entity.Source"
                          [routeEndpoint]="'Sources'"
                          [limitToList]="false"
                          [pageSize]="30"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get('marketingSourceId')
              "
                        ></app-typeahead>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
